import React from 'react';
import { Spinner } from '@treelab/panda';

import { Container } from './styled';

const Loading = () => (
  <Container>
    <Spinner></Spinner>
  </Container>
);

export default Loading;
